import axios from "axios";

const getDefaultState = () => {
  return {
    circles: null,
    mobileSideMenuClicked: false,
    currentCircle: null,
    circleMembers: {
      self: {
        virtualDoctors: [],
        data: [],
        count: 0
      },
      others: {
        data: [],
        count: 0
      },
      providers: {
        data: [],
        count: 0
      },
      hospitals: {
        data: [],
        count: 0
      },
      clinics: {
        data: [],
        count: 0
      },
      hcps: {
        data: [],
        count: 0
      },
      nfps: {
        data: [],
        count: 0
      }
    },
    viewCircleMembers: {
      self: {
        data: [],
        count: 0
      },
      others: {
        data: [],
        count: 0
      },
      providers: {
        data: [],
        count: 0
      },
      hospitals: {
        data: [],
        count: 0
      },
      clinics: {
        data: [],
        count: 0
      },
      hcps: {
        data: [],
        count: 0
      },
      nfps: {
        data: [],
        count: 0
      }
    },
    circleDiseaseTypes: []
  };
};

const state = getDefaultState();

const getters = {
  circles: state => state.circles,
  currentCircle: state => state.currentCircle,
  mobileSideMenuClicked: state => state.mobileSideMenuClicked,
  circleMembers: state => state.circleMembers,
  viewCircleMembers: state => state.viewCircleMembers,
  circleDiseaseTypes: state => state.circleDiseaseTypes
};

const mutations = {
  setCurrentCircle: (state, { data }) => {
    state.currentCircle = data;
    // console.log('currentCricle state ->', data);
    localStorage.setItem("currentCircle", JSON.stringify(data));
  },

  setMobileSideMenuClicked: (state, { data }) => {
    state.mobileSideMenuClicked = data;
    localStorage.setItem("mobileSideMenuClicked", JSON.stringify(data));
  },

  setSelfCircleMembers: (state, data) => {
    state.circleMembers.self.data = data.data;
    state.circleMembers.self.virtualDoctors = data;
    state.circleMembers.self.count = data.pagination.total_count;
  },

  setOtherCircleMembers: (state, data) => {
    state.circleMembers.others.data = data.data;
    state.circleMembers.others.count = data.pagination.total_count;
  },

  setProvidersCircleMembers: (state, data) => {
    state.circleMembers.providers.data = [
      ...data.data.doctors.virtual_doctors,
      ...data.data.doctors.circle_doctors,
      ...data.data.doctors.recommended_doctors
    ];

    state.circleMembers.providers.count =
      data.data.doctors.doctors_paginator.total_count;

    state.circleMembers.hospitals.data = [
      ...data.data.hospitals.virtual_hospitals,
      ...data.data.hospitals.circle_hospitals
    ];

    state.circleMembers.hospitals.count =
      data.data.hospitals.hospitals_paginator.total_count;

    state.circleMembers.clinics.data = [
      ...data.data.clinics.virtual_clinics,
      ...data.data.clinics.circle_clinics
    ];
    state.circleMembers.clinics.count =
      data.data.clinics.clinics_paginator.total_count;

    state.circleMembers.hcps.data = [
      ...data.data.hcps.virtual_hcps,
      ...data.data.hcps.circle_hcps
    ];
    state.circleMembers.hcps.count = data.data.hcps.hcps_paginator.total_count;

    state.circleMembers.nfps.data = [
      ...data.data.nfps.virtual_nfp,
      ...data.data.nfps.circle_nfps
    ];
    state.circleMembers.nfps.count = data.data.nfps.nfps_paginator.total_count;
  },

  setViewSelfCircleMembers: (state, data) => {
    // state.viewCircleMembers.self.data.push(...data.data)
    state.viewCircleMembers.self.data = data ? data.data : [];
    state.viewCircleMembers.self.count = data.pagination.total_count;
  },

  setViewOtherCircleMembers: (state, data) => {
    // state.viewCircleMembers.others.data.push(...data.data)
    state.viewCircleMembers.others.data = data ? data.data : [];
    state.viewCircleMembers.others.count = data.pagination.total_count;
  },

  setViewProvidersCircleMembers: (state, data) => {
    state.viewCircleMembers.providers.data = [
      ...data.data.doctors.virtual_doctors,
      ...data.data.doctors.circle_doctors,
      ...data.data.doctors.recommended_doctors
    ];

    state.viewCircleMembers.providers.count =
      data.data.doctors.doctors_paginator.total_count;

    state.viewCircleMembers.hospitals.data = [
      ...data.data.hospitals.virtual_hospitals,
      ...data.data.hospitals.circle_hospitals
    ];
    state.viewCircleMembers.hospitals.count =
      data.data.hospitals.hospitals_paginator.total_count;

    state.viewCircleMembers.clinics.data = [
      ...data.data.clinics.virtual_clinics,
      ...data.data.clinics.circle_clinics
    ];
    state.viewCircleMembers.clinics.count =
      data.data.clinics.clinics_paginator.total_count;

    state.viewCircleMembers.hcps.data = [
      ...data.data.hcps.virtual_hcps,
      ...data.data.hcps.circle_hcps
    ];
    state.viewCircleMembers.hcps.count =
      data.data.hcps.hcps_paginator.total_count;

    state.viewCircleMembers.nfps.data = [
      ...data.data.nfps.virtual_nfp,
      ...data.data.nfps.circle_nfps
    ];
    state.viewCircleMembers.nfps.count =
      data.data.nfps.nfps_paginator.total_count;
  },

  setCircleDiseaseTypes: (state, data) => {
    state.circleDiseaseTypes = data.data;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  circles: async ({ dispatch, commit }, { headers }) => {
    axios
      .get(`${process.env.BASE_API_URL}/allcircle/`, { headers })
      .then(res => {
        commit("setCircles", { data: res.data.data });
      })
      .catch();
  },

  diseaseTypes: async ({ dispatch, commit }, { type }) => {
    axios
      .get(
        `${process.env.BASE_API_URL}/mastertable/?type=disease_type&value=${type}`
      )
      .then(res => {
        if (res.data) {
          commit("setCircleDiseaseTypes", { data: res.data.data });
        }
      })
      .catch();
  },

  resetCircleState({ commit }) {
    commit("resetState");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Circle.js